<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:36:18
 * @LastEditTime: 2019-08-29 16:26:47
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class='noListStyle'>
        <img :src="noListUrl" alt="">
        <p>暂无数据！</p>
    </div>
</template>

<script>
export default {
    data () {
        return {
            noListUrl: require('@/assets/img/myCenter/noList.png')
        };
    }
};
</script>
<style lang="scss" scoped>
.noListStyle {
    text-align: center;
    img {
        width: 203px;
    }
    p {
        color: #999;
        padding-top: 20px;
        text-align: center;
    }
}
</style>
